import { type Theme } from "@mui/material/styles";
import { Card as MuiCard } from "./card";
import { Chip as MuiChip } from "./chip";
import { link as MuiLink } from "./link";
import { List as MuiList } from "./list";
import { Menu as MuiMenu } from "./menu";
import { Tabs as MuiTabs } from "./tabs";
import { input as MuiInput } from "./input";
import { paper as MuiPaper } from "./paper";
import { Table as MuiTable } from "./table";
import { Alert as MuiAlerts } from "./alerts";
import { Button as MuiButton } from "./button";
import { Dialog as MuiDialog } from "./dialog";
import { Rating as MuiRating } from "./rating";
import { select as MuiSelect } from "./select";
import { Avatar as MuiAvatar } from "./avatars";
import { Divider as MuiDivider } from "./divider";
import { Popover as MuiPopover } from "./popover";
import { Tooltip as MuiTooltip } from "./tooltip";
import { Backdrop as MuiBackdrop } from "./backdrop";
import { Snackbar as MuiSnackbar } from "./snackbar";
import { Switch as MuiSwitches } from "./switches";
import { Timeline as MuiTimeline } from "./timeline";
import { Accordion as MuiAccordion } from "./accordion";
import { Pagination as MuiPagination } from "./pagination";
import { Typography as MuiTypography } from "./typography";
import { toggleButton as MuiToggleButton } from "./toggle-button";
import { DateTimePicker as MuiDateTimePicker } from "./date-time-picker";

const Overrides = (theme: Theme) => {
  const chip = MuiChip(theme);
  const list = MuiList(theme);
  const menu = MuiMenu(theme);
  const tabs = MuiTabs(theme);
  const cards = MuiCard(theme);
  const input = MuiInput(theme);
  const tables = MuiTable(theme);
  const alerts = MuiAlerts(theme);
  const button = MuiButton(theme);
  const rating = MuiRating(theme);
  const avatars = MuiAvatar(theme);
  const divider = MuiDivider(theme);
  const dialog = MuiDialog(theme);
  const popover = MuiPopover(theme);
  const tooltip = MuiTooltip(theme);
  const backdrop = MuiBackdrop(theme);
  const snackbar = MuiSnackbar(theme);
  const switches = MuiSwitches(theme);
  const timeline = MuiTimeline(theme);
  const accordion = MuiAccordion(theme);
  const pagination = MuiPagination(theme);
  const dateTimePicker = MuiDateTimePicker(theme);

  return Object.assign(
    chip,
    list,
    menu,
    tabs,
    cards,
    input,
    alerts,
    button,
    dialog,
    rating,
    tables,
    avatars,
    divider,
    MuiLink,
    popover,
    tooltip,
    backdrop,
    MuiPaper,
    snackbar,
    switches,
    timeline,
    accordion,
    MuiSelect,
    pagination,
    MuiTypography,
    dateTimePicker,
    MuiToggleButton,
  );
};

export { Overrides };
